'use strict';
const angular = require('angular');

/*@ngInject*/
export function AppConfigService(APP_CONFIG) {
  // Service logic
  // ...

  const appConfig = APP_CONFIG.data;

  const modules = {
    General: "general",
    FrontPage: "frontpage",
    Document: "document",
    Calendar: "calendar",
    Bulletin: "bulletin",
    Piper: "piper",
    Directories: "directories",
    Gallery: "gallery",
    Forum: "forum",
    News: "news",
    SignUp: "signup",
    Profile: "profile",
    MailBlast: "mailblast",
    Reservation: "reservation",
    Payment: "payment",
    Quickbooks: "quickbooks"
  };

  let customPageTitles = {};
  let pagination = {};

  appConfig.modules.forEach(module => {
    if (appConfig.moduleConfig
      && appConfig.moduleConfig[module]) {

      if (appConfig.moduleConfig[module].customPageTitle) {
        customPageTitles = angular.extend(customPageTitles, appConfig.moduleConfig[module].customPageTitle);
      }

      if (appConfig.moduleConfig[module].pagination) {
        pagination = angular.extend(pagination, appConfig.moduleConfig[module].pagination);
      }
    }
  });

  let PublicAPI = {
    Modules: modules,
    getAppConfig() {
      return appConfig;
    },
    getPageTitleByStateWithDefault(state, defaultPageTitle) {
      if (!state) {
        return defaultPageTitle || "Page";
      }

      let title = defaultPageTitle || state.split('-').join(' ');

      return customPageTitles[state] || title;
    },
    getPagination(key) {
      if (!key)
        return 10;

      return pagination[key] || 10;
    },
    getPaginationWithDefault(key, defaultValue) {
      if (!key)
        return defaultValue;

      return pagination[key] || defaultValue;
    },
    isModuleEnabled(module) {
      return appConfig.modules && appConfig.modules.indexOf(module) !== -1;
    },
    getModuleConfig(module) {
      if (!appConfig.moduleConfig || !this.isModuleEnabled(module)) {
        return {};
      }

      return appConfig.moduleConfig[module];
    }
  };

  let GeneralConfig = appConfig.moduleConfig[modules.General];

  if (GeneralConfig) {
    GeneralConfig.getClientName = () => GeneralConfig.clientName;
    GeneralConfig.getClientLocation = () => GeneralConfig.clientLocation;
    GeneralConfig.getClientTimezone = () => GeneralConfig.timezone;
    GeneralConfig.getClientBuildings = () => GeneralConfig.buildings || [];
    GeneralConfig.getClientUnits = () => GeneralConfig.units || {};
    GeneralConfig.getClientAssociations = () => GeneralConfig.associations || [];

    GeneralConfig.getFrontLevelPages = () => GeneralConfig.frontLevelPages || [];

    /* Move both from client to app.general */
    GeneralConfig.showUserMenuLabel = () => GeneralConfig.showUserMenuLabel;
    GeneralConfig.getUserMenuLabel = () => GeneralConfig.userMenuLabel;
  }

  let FrontPageConfig = appConfig.moduleConfig[modules.FrontPage];

  if (FrontPageConfig) {
    FrontPageConfig.getFlavor = () => FrontPageConfig.frontpageType || "classic";
  }

  let DocumentConfig = appConfig.moduleConfig[modules.Document];

  if (DocumentConfig) {
    DocumentConfig.getTypes = () => DocumentConfig.documentType || [];
    DocumentConfig.getDefaultUploadType = () => DocumentConfig.defaultDocumentUploadType || DocumentConfig.documentType[0];
    DocumentConfig.getPageCategories = () => DocumentConfig.documentPageCategories || {};
    DocumentConfig.getNavStyle = () => DocumentConfig.navStyle || 'tabs';
    DocumentConfig.getTypesByCategory = (cat) => {
      return (DocumentConfig.documentPageCategories && DocumentConfig.documentPageCategories[cat])
        ? DocumentConfig.documentPageCategories[cat]
        : DocumentConfig.documentType;
    };
    DocumentConfig.getPageTitleByCategory = (cat) => {
      return (DocumentConfig.documentPageTitle && DocumentConfig.documentPageTitle[cat])
        ? DocumentConfig.documentPageTitle[cat]
        : "Documents";
    };
    DocumentConfig.getDocumentTree = _ => DocumentConfig.documentTree || [];
    DocumentConfig.getDefaultPermissionByType = _ => DocumentConfig.defaultPermissionByType || {};
    DocumentConfig.getPageRoleRestriction = _ => DocumentConfig.documentPageRoleRestriction || {};
  }

  let DirectoriesConfig = appConfig.moduleConfig[modules.Directories];

  if (DocumentConfig) {
    DirectoriesConfig.getImportantNumberCategories = () => DirectoriesConfig.importantNumberCategories || [];
    DirectoriesConfig.getImportantNumberCategoryIcons = () => DirectoriesConfig.importantNumberCategoryIcons || {};
    DirectoriesConfig.getImportantNumberNavStyle = () => DirectoriesConfig.importantNumberNavStyle || 'tabs';

    DirectoriesConfig.getBoardAndStaffSetting = () => DirectoriesConfig.boardAndStuffSettingName || "board-and-staff";
    DirectoriesConfig.getBoardAndStaffTypes = () => DirectoriesConfig.boardAndStaffTypes || ['Board','Staff'];
    DirectoriesConfig.getBoardAndStaffContactTypes = () => DirectoriesConfig.boardAndStaffContactTypes || [];

    DirectoriesConfig.getVendorCategories = () => DirectoriesConfig.vendorCategories || [];
    DirectoriesConfig.getVendorSelectType = () => DirectoriesConfig.vendorSelectType;
    DirectoriesConfig.getVendorInfo = () => DirectoriesConfig.vendorInfo;
    DirectoriesConfig.getVendorNavStyle = () => DirectoriesConfig.vendorNavStyle || 'tabs';

    DirectoriesConfig.getBuildingAsAddress = () => DirectoriesConfig.buildingAsAddress;

    DirectoriesConfig.getPermissions = () => DirectoriesConfig.permission || {};

    DirectoriesConfig.getResidentDirectoryContactTypes = () => DirectoriesConfig.residentDirectoryContactTypes || ["primary-owner", "owner"];
    DirectoriesConfig.getResidentDirectoryAddressTypes = () => DirectoriesConfig.residentDirectoryAddressTypes || [];
  }

  let CalendarConfig = appConfig.moduleConfig[modules.Calendar];

  if (CalendarConfig) {
    CalendarConfig.getEventTypes = () => CalendarConfig.calendarEventType || [];
    CalendarConfig.getTypesUserContribution = () => CalendarConfig.calendarEventUserContributionAllowed || [];
    CalendarConfig.getCalendarConfig = () => CalendarConfig.calendarConfig || {};
    CalendarConfig.getCalendarGroup = () => CalendarConfig.calendarGroup || {};
  }

  let GalleryConfig = appConfig.moduleConfig[modules.Gallery];

  if (GalleryConfig) {
    GalleryConfig.getTypes = () => GalleryConfig.galleryType || [];
    GalleryConfig.getTypesUserContribution = () => GalleryConfig.galleryUserContributionAllowed || [];
  }

  let ForumConfig = appConfig.moduleConfig[modules.Forum];

  if (ForumConfig) {
    ForumConfig.getCategoryKeys = () => ForumConfig.forumCategoryKeys || ['general'];
    ForumConfig.getCategories = () => ForumConfig.forumCategories || {'general':{name:'General'}};
  }

  let NewsConfig = appConfig.moduleConfig[modules.News];

  if (NewsConfig) {
    NewsConfig.getTypes = () => NewsConfig.newsType || ['news'];
    NewsConfig.getDefaultType = () => NewsConfig.defaultNewsType || NewsConfig.newsType[0];
    NewsConfig.getPublicAllowed = () => NewsConfig.publicAllowed || false;
  }

  let BulletinConfig = appConfig.moduleConfig[modules.Bulletin];

  if (BulletinConfig) {
    BulletinConfig.isReviewActive = () => BulletinConfig.bulletinBoardReview || false;
    BulletinConfig.getCategories = () => BulletinConfig.bulletinBoardCategories || [];
    BulletinConfig.getNavStyle = () => BulletinConfig.navStyle || 'tabs';
  }

  let SignUpConfig = appConfig.moduleConfig[modules.SignUp];

  if (SignUpConfig) {
    SignUpConfig.getActivationCode = () => SignUpConfig.activationCode;
    SignUpConfig.getActivationCodeGroups = () => SignUpConfig.activationCodeGroups || [];
    SignUpConfig.getInfoTexts = () => SignUpConfig.signUpInfo || {};
    SignUpConfig.getResidencyRelationsConfig = () => SignUpConfig.residencyRelationsOnSignUpFormular || {};
    SignUpConfig.isResidencyRelationsRequired = () => {
      return (SignUpConfig.residencyRelationsOnSignUpFormular && SignUpConfig.residencyRelationsOnSignUpFormular.visible)
        ? SignUpConfig.residencyRelationsOnSignUpFormular.visible
        : false;
    };
    SignUpConfig.getDeactivated = () => SignUpConfig.deactivated || false;
    SignUpConfig.getPreHookHtml = () => SignUpConfig.preHookHtml;
    SignUpConfig.getPostHookHtml = () => SignUpConfig.postHookHtml;
    SignUpConfig.getAssociationInfo = () => SignUpConfig.associationOnSignUpFormular || {};

    SignUpConfig.getAdminAddUser = () => SignUpConfig.adminAddUser || false;
    SignUpConfig.getAdminAddUserSendEmailDefault = () => SignUpConfig.adminAddUserSendEmailDefault || false;
  }

  let ProfileConfig = appConfig.moduleConfig[modules.Profile];

  if (ProfileConfig) {
    ProfileConfig.getGenderTypes = () => ProfileConfig.gender || [];
    ProfileConfig.getDefaultGender = () => ProfileConfig.defaultGender || ProfileConfig.gender[0];

    ProfileConfig.getPhoneTypes = () => ProfileConfig.phoneTypes || [];
    ProfileConfig.getDefaultPhoneType = () => ProfileConfig.defaultPhoneType || ProfileConfig.phoneTypes[0];
    ProfileConfig.getDefaultPhoneTypeWork = () => ProfileConfig.defaultPhoneTypeWork || ProfileConfig.phoneTypes[0];

    ProfileConfig.getMailTypes = () => ProfileConfig.mailTypes || [];
    ProfileConfig.getDefaultMailType = () => ProfileConfig.defaultMailType || ProfileConfig.mailTypes[0];
    ProfileConfig.getDefaultMailTypeWork = () => ProfileConfig.defaultMailTypeWork || ProfileConfig.mailTypes[0];
    ProfileConfig.getDefaultMailTypeSignUpEmail = () => ProfileConfig.defaultMailTypeForSignUpEmail || ProfileConfig.mailTypes[0];

    ProfileConfig.getAddressTypes = () => ProfileConfig.addressTypes || [];
    ProfileConfig.getDefaultAddressType = () => ProfileConfig.defaultAddressType || ProfileConfig.addressTypes[0];
    ProfileConfig.getDefaultAddressTypeWork = () => ProfileConfig.defaultAddressTypeWork || ProfileConfig.addressTypes[0];

    ProfileConfig.getSocialMediaTypes = () => ProfileConfig.socialMediaTypes || [];
    ProfileConfig.getDefaultSocialMediaType = () => ProfileConfig.defaultSocialMediaType || ProfileConfig.socialMediaTypes[0];
    ProfileConfig.getDefaultSocialMediaTypeWork = () => ProfileConfig.defaultSocialMediaTypeWork || ProfileConfig.socialMediaTypes[0];

    ProfileConfig.getResidencyRelationTypes = () => ProfileConfig.residencyRelationType || [];
    ProfileConfig.getDefaultResidencyRelationType = () => ProfileConfig.defaultResidencyRelationType || ProfileConfig.residencyRelationType[0];
    ProfileConfig.getResidencyRelationTexts = () => ProfileConfig.profileResidencyRelations || {};
    ProfileConfig.getLabelPrivate = () => ProfileConfig.profileLabelPrivate || 'Private';
    ProfileConfig.getLabelPublic = () => ProfileConfig.profileLabelPublic || 'Public';

    ProfileConfig.getPermissions = () => ProfileConfig.permission || {};
    ProfileConfig.getUseShortAddressFormat = () => ProfileConfig.useShortAddressFormat || false;

    ProfileConfig.getAssociationInfo = () => ProfileConfig.associationOnProfile || {};

    ProfileConfig.getHideResidencyRelations = () => ProfileConfig.hideResidencyRelations;

    ProfileConfig.getCustomFieldTypes = () => ProfileConfig.customFieldTypes || [];
    ProfileConfig.getDefaultCustomFieldType = () => ProfileConfig.defaultCustomFieldType ||  '';
    ProfileConfig.getCustomFieldIcons = () => ProfileConfig.customFieldIcons || {};

    ProfileConfig.getInvisibleProfileParts = () => ProfileConfig.invisibleProfileParts || {"customFields": true};

    ProfileConfig.getAdminOnlyResidencyRelations = () => ProfileConfig.adminOnlyResidencyRelations || false;

    ProfileConfig.getUserDirectoryDisplayRoles = () => ProfileConfig.userDirectoryDisplayRoles || ["user"];
  }

  let MailBlastConfig = appConfig.moduleConfig[modules.MailBlast];

  if (MailBlastConfig) {
    MailBlastConfig.getArchiveCategories = () => MailBlastConfig.mailArchiveCategories || [];
    MailBlastConfig.getSystemRecipientLists = () => MailBlastConfig.systemRecipientLists || [];
    MailBlastConfig.getDirectoryRecipientLists = () => MailBlastConfig.directoryRecipientLists || [];
    MailBlastConfig.getSystemRecipientListsAssociation = () => MailBlastConfig.systemRecipientListsAssociation || [];
    MailBlastConfig.getSuiteRecipientLists = () => MailBlastConfig.suiteRecipientLists || [];
    MailBlastConfig.getHideViewOnline = () => MailBlastConfig.hideViewOnline;
    MailBlastConfig.getBlacklist = () => MailBlastConfig.blacklist || [];
  }

  let ReservationConfig = appConfig.moduleConfig[modules.Reservation];

  if (ReservationConfig) {
    ReservationConfig.getEventTypes = () => ReservationConfig.eventTypes || [];
    ReservationConfig.getTypes = () => ReservationConfig.reservationTypes || [];
    ReservationConfig.getEventSettings = () => ReservationConfig.eventTypeConfig || {};
    ReservationConfig.getSettings = () => ReservationConfig.reservationTypeConfig || {};
    ReservationConfig.getCalendarConfig = () => ReservationConfig.calendarConfig || {};
  }

  let PaymentsConfig = appConfig.moduleConfig[modules.Payment];

  if (PaymentsConfig) {
    PaymentsConfig.getTargetAccounts = () => PaymentsConfig.targetAccounts || {};
  }

  let QuickbooksConfig = appConfig.moduleConfig[modules.Quickbooks];

  if (QuickbooksConfig) {
    QuickbooksConfig.getShowRunningBalance = () => QuickbooksConfig.showRunningBalance;
  }

  // Public API here
  return PublicAPI;
}


export default angular.module('conduu.services.AppConfigService', [])
  .factory('AppConfig', AppConfigService)
  .name;



// WEBPACK FOOTER //
// ./client/services/config/config.service.js